// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"L2-z","sponsoredTooltipWrapper":"M2-z","sponsoredTooltip":"N2-z","newCard":"O2-z"};